import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import Stepper from 'react-stepper-horizontal';
import { nextStep, prevStep, resetStep } from '../store/actions/commonActions';
import ProgressingButton from '../common/ProgressingButton';

class Wizard extends Component {

  constructor(props) {
    super(props);
    this.wizardForms = [];
    this.steps = [];
  }

  componentWillUnmount() {
    this.props.resetStep();
  }

  componentDidMount() {
    this.props.resetStep();
  }

  displayCurrentForm = () => {
    // return this.wizardForms[this.props.common.activeStep];
    this.wizardForms = this.props.children;
    if (this.wizardForms.length) {
      this.steps = this.wizardForms.map((wizardStep, id) => {
        const title = wizardStep.props.stepTitle;
        if (typeof(title) !== "undefined") {
          return {title, id}
        }
        else {
          alert('Invalid Wizard Step. Please provide Step Title.');
          return false;
        }
      })
      
      return this.wizardForms[this.props.common.activeStep];
    }
    
    return '';
  }

  navigationButtons = () => {

    const activeStep = this.props.common.activeStep;

    return (
      <Row className="mt-3">
        <Col>

          <div className="float-left">
            <Button variant="link"  onClick={() => {
                this.props.onCancel();
              }}>Cancel</Button>
          </div>
          <div className="float-right">
            {activeStep !== 0 && <Button variant="outline-primary" className="mr-3" onClick={() => {
              this.props.prevStep();
            }}>Prev</Button>}
            { activeStep === (this.steps.length - 1) ? (
              <ProgressingButton 
                className="mr-3" 
                variant="primary" 
                disabled={this.props.common.isSaving ? true : false}
                buttonValue="Save Project"
                onClick={() => {
                  if (typeof(this.wizardForms[activeStep].props.onValidate) !== 'undefined' && this.wizardForms[activeStep].props.onValidate()){
                    this.props.onSave();
                  }
                }} />
            ) : (
              <Button onClick={() => {
                //check validation before proceeding to next step
                if (typeof(this.wizardForms[activeStep].props.onValidate) !== 'undefined' && this.wizardForms[activeStep].props.onValidate()) {
                  if (typeof(this.wizardForms[activeStep].props.onNextStep) !== "undefined") {
                    this.wizardForms[activeStep].props.onNextStep();
                  }

                  this.props.nextStep(this.steps);
                }
              }}>Next</Button>
            )}
          </div>
        </Col>
      </Row>
    )
  }

  render() {
    return (
      <>
        <Stepper steps={ this.steps } activeStep={ this.props.common.activeStep } />
        <Row className="mt-3">
          <Col>
            { this.displayCurrentForm() }
          </Col>
        </Row>
        { this.navigationButtons() }
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  common: state.common 
})

const mapDispatchToProps = (dispatch) => {
  return {
    nextStep: (...args) => dispatch(nextStep(...args)),
    prevStep: (...args) => dispatch(prevStep(...args)),
    resetStep: () => dispatch(resetStep())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Wizard)
